import { useBlackFriday } from '../../../context/blackFridayContext'
import usePromoCountdown from '../../../context/usePromoCountdown'
import useStrings from '../../../localization/useStrings'
import style from './Countdown.module.scss'

interface CountdownProps {
  showExpires: boolean
}

const Countdown = ({ showExpires }: CountdownProps) => {
  const { minutes, hours, seconds, hourUnit, minuteUnit, secondUnit } = usePromoCountdown()
  const strings = useStrings()

  return (
    <div className={`${style.container}`}>
      <CountdownItem value={hours} unit={hourUnit} />
      <CountdownItem value={minutes} unit={minuteUnit} />
      <CountdownItem value={seconds} unit={secondUnit} />
      {showExpires && <div className={style.expires}>{strings.offerExpires}</div>}
    </div>
  )
}

const CountdownItem = (props: { value: number; unit: string }) => {
  const isUltimate = useBlackFriday().state.isUltimate

  return (
    <div className={`${style.item} ${isUltimate ? style.itemUltimate : style.itemPremium}`}>
      <label className={style.value}>{props.value}</label>
      <label className={style.unit}>{props.unit}</label>
    </div>
  )
}

export default Countdown
